import React from 'react';

const LocationIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" /></svg>;

const MapComponent = ({ data }) => {
    if (!data || !data.location) return null;

    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(data.location)}`;

    return (
        <div className="mt-2 mb-2 max-w-xs sm:max-w-sm flex items-center p-3 bg-[var(--bg-secondary)] border border-[var(--border-subtle)]/50 shadow-sm rounded-2xl w-full">
            <div className="w-10 h-10 rounded-full bg-red-500/10 flex items-center justify-center mr-3 shrink-0">
                <LocationIcon className="w-6 h-6 text-red-500" />
            </div>
            <div className="flex-1 min-w-0 pr-3">
                <h4 className="text-sm font-bold text-[var(--text-main)] truncate">{data.location}</h4>
                <p className="text-xs text-[var(--text-muted)] truncate mt-0.5">
                    {data.lat && data.lng ? `${data.lat}, ${data.lng}` : 'Location Pin'}
                </p>
            </div>
            <a
                href={googleMapsUrl}
                target="_blank"
                rel="noreferrer"
                className="px-3 py-1.5 bg-[var(--bg-tertiary)] hover:bg-[var(--bg-secondary)] text-[var(--accent-primary)] hover:text-[var(--accent-hover)] text-xs font-bold rounded-lg transition-colors border border-[var(--border-subtle)]/50 shrink-0"
            >
                View
            </a>
        </div>
    );
};

export default MapComponent;
